/**
 * @param {string} pathname
 * @param {string} [route]
 */
export function isRouteActive(pathname, route) {
  if (!route) return false;

  if (route.startsWith('/#/')) {
    const hashRoute = route.replace('/#', '#');
    return window.location.hash === hashRoute || `${window.location.pathname}${window.location.hash}` === route;
  }

  const pathOnly = route.split('?')[0];
  return pathname === pathOnly || pathname.startsWith(`${pathOnly}/`);
}

/**
 * @param {string} pathname
 * @param {import('../../config/navigation/navigation.constants.js').NavLeaf[]} [children]
 */
export function isAnyChildRouteActive(pathname, children) {
  for (const child of children || []) {
    if (child.route && isRouteActive(pathname, child.route)) return true;
    if (child.children && isAnyChildRouteActive(pathname, child.children)) return true;
  }
  return false;
}

/**
 * @param {string} route
 * @param {import('react-router-dom').NavigateFunction} navigate
 */
export function navigateToRoute(route, navigate) {
  if (!route) return;

  if (route.startsWith('/#/')) {
    window.location.href = route;
    return;
  }

  navigate(route);
}

/**
 * @param {import('../../config/navigation/navigation.constants.js').NavItem} item
 * @param {string} pathname
 */
export function isNavItemActive(item, pathname) {
  if (!item) return false;
  if (item.route && isRouteActive(pathname, item.route)) return true;
  return isAnyChildRouteActive(pathname, item.children);
}
